import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { SignatureModel } from '../../../../../types';
import { pagesConfig } from '../../../../shared/pages-config';

export function useSignatureTemplateActions() {
  const navigate = useNavigate();
  const [, setSearchParams] = useSearchParams();

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [templateForDelete, setTemplateForDelete] =
    useState<SignatureModel | null>(null);
  const [changeLogMessage, setChangeLogMessage] = useState('');
  const [openChangeLogDialog, setOpenChangeLogDialog] = useState(false);

  const closeDrawer = () => {
    setSearchParams((prev) => {
      prev.delete('selectedTemplate');
      return prev;
    });
  };

  const handleEditTemplate = (template: SignatureModel) => {
    navigate({
      pathname: `/${
        pagesConfig.signatureTemplates.link
      }/${pagesConfig.editSignatureTemplate.link.replace(
        ':id',
        template.id.toString()
      )}`,
    });
  };

  const handleCloneTemplate = (template: SignatureModel) => {
    navigate({
      pathname: `/${
        pagesConfig.signatureTemplates.link
      }/${pagesConfig.cloneSignatureTemplate.link.replace(
        ':id',
        template.id.toString()
      )}`,
    });
  };

  const handleDeleteTemplate = (template: SignatureModel) => {
    setTemplateForDelete(template);
    setOpenDeleteDialog(true);
  };

  const openChangeLog = () => {
    setOpenChangeLogDialog(true);
  };

  const closeChangeLog = () => {
    setOpenChangeLogDialog(false);
    setChangeLogMessage('');
  };

  const closeDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setTemplateForDelete(null);
    setChangeLogMessage('');
  };

  return {
    closeDrawer,
    handleEditTemplate,
    handleCloneTemplate,
    handleDeleteTemplate,
    openDeleteDialog,
    setOpenDeleteDialog,
    closeDeleteDialog,
    templateForDelete,
    setTemplateForDelete,
    changeLogMessage,
    setChangeLogMessage,
    openChangeLogDialog,
    openChangeLog,
    closeChangeLog,
  };
}
